import { defaultHttpClient } from '../../httpClient';
import type { ScreensMetaResponse } from './types';

interface GetScreensMetaParams {
  screen: string;
  next_token?: string;
}

export const getScreensMeta = async ({
  screen,
  next_token,
}: GetScreensMetaParams) => {
  const { data } = await defaultHttpClient.request<ScreensMetaResponse>({
    method: 'GET',
    url: `/api/v2/screens/${screen}/meta`,
    params: {
      ...(next_token && { next_token }),
    },
  });
  return data;
};
